export default __webpack_public_path__ + "static/media/SELLOS_03.0528caaf.png";